/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_RedInputs */

const en_val_red = /** @type {(inputs: Val_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Red`)
};

const es_val_red = /** @type {(inputs: Val_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinto`)
};

const fr_val_red = /** @type {(inputs: Val_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rouge`)
};

const de_val_red = /** @type {(inputs: Val_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotwein`)
};

const ja_val_red = /** @type {(inputs: Val_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赤ワイン`)
};

const zh_val_red = /** @type {(inputs: Val_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`红葡萄酒`)
};

const ar_val_red = /** @type {(inputs: Val_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نبيذ أحمر`)
};

const id_val_red = /** @type {(inputs: Val_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merah`)
};

const it_val_red = /** @type {(inputs: Val_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rosso`)
};

const ru_val_red = /** @type {(inputs: Val_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Красное`)
};

const pt_val_red = /** @type {(inputs: Val_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinto`)
};

const ko_val_red = /** @type {(inputs: Val_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레드`)
};

/**
* | output |
* | --- |
* | "Red" |
*
* @param {Val_RedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_red = /** @type {((inputs?: Val_RedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_RedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_red(inputs)
	if (locale === "es") return es_val_red(inputs)
	if (locale === "fr") return fr_val_red(inputs)
	if (locale === "de") return de_val_red(inputs)
	if (locale === "ja") return ja_val_red(inputs)
	if (locale === "zh") return zh_val_red(inputs)
	if (locale === "ar") return ar_val_red(inputs)
	if (locale === "id") return id_val_red(inputs)
	if (locale === "it") return it_val_red(inputs)
	if (locale === "ru") return ru_val_red(inputs)
	if (locale === "pt") return pt_val_red(inputs)
	return ko_val_red(inputs)
});